var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56703 11.749C4.28323 11.1111 4.125 10.4013 4.125 9.65344C4.125 6.87577 6.30761 4.62402 9 4.62402C11.6924 4.62402 13.875 6.87577 13.875 9.65344C13.875 10.4013 13.7168 11.1111 13.433 11.749",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 1.99902V2.74902",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.49902H15.75",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.49951H1.5",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3028 4.1958L13.7725 4.72613",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2276 4.72711L3.69727 4.19678",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8867 14.9791C11.6445 14.734 11.9484 14.0404 12.0339 13.3427C12.0594 13.1343 11.8879 12.9614 11.6779 12.9614L6.35654 12.9616C6.13934 12.9616 5.96491 13.1459 5.99084 13.3615C6.07458 14.0578 6.28593 14.5665 7.08899 14.9791M10.8867 14.9791C10.8867 14.9791 7.22119 14.9791 7.08899 14.9791M10.8867 14.9791C10.7955 16.4378 10.3743 17.0156 9.00401 16.9994C7.53836 17.0264 7.20118 16.3124 7.08899 14.9791",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.82f916428cfc9ffb7788297cd7d94f88.svg";
export { ForwardRef as ReactComponent };